

import Vue from 'vue'
import App from './App'
import router from './router'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import axios from 'axios'
import Qs from 'qs'

Vue.prototype.axios = axios
Vue.prototype.qs = Qs
Vue.use(AjaxPlugin)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js